import { Redirect, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { signInLocation, pathOfLocation } from "../utils/signInReturn";
// import PropTypes from "prop-types";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  // ProtectedRoute.propTypes = {
  //   component: PropTypes.object.isRequired,
  // };

  const location = useLocation();
  const user = useSelector((state) => state.user.currentUser);

  return (
    <Route {...rest}>
      {user ? (
        <Component />
      ) : (
        /* The query parameter outlives a hop to /register, the state keeps
           this location's own state; signInReturn reads whichever survived. */
        <Redirect to={{ ...signInLocation(pathOfLocation(location)), state: { from: location } }} />
      )}
    </Route>
  );
};

export default ProtectedRoute;
